import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SharedModule } from '../shared/shared.module';
import { HomeRoutingModule } from './home-routing.module';
import { MomentModule } from 'ngx-moment';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { HomeNewComponent } from './home-new/home-new.component';


@NgModule({
  declarations: [HomeComponent, HomeNewComponent],
  imports: [
    CommonModule,
    SlickCarouselModule,
    HomeRoutingModule,
    MomentModule,
    SharedModule,
  ],
  providers: [
    AllPageService
  ],
})
export class HomeModule { }
